import { Popover, PopoverProps } from '@mui/material';

type Props = PopoverProps;

export function DatePickerPopover({ PaperProps, ...props }: Props) {
  return (
    <Popover
      keepMounted
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      {...props}
      PaperProps={{
        elevation: 0,
        ...PaperProps,
        sx: {
          background: 'var(--Gray-50, #F9FAFB)',
          overflow: 'hidden',
          borderRadius: '12px',
          border: `1px solid var(--Gray-300, #D0D5DD)`,
          display: 'flex',
          flexDirection: 'column',
          width: '325px',
          alignItems: 'center',
          boxShadow: `0px 0px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)`,
          transition: 'height 0.3s ease',
          marginTop: '-10px',
          ...PaperProps?.sx,
        },
      }}
    />
  );
}
